import React from 'react';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { BsCheck, BsCheckAll } from 'react-icons/bs';
import { MdError } from 'react-icons/md';

export function getStatusIcon(status) {
  const situation = typeof status === 'string' ? status : status?.situation;

  switch (situation) {
    // Esse status é usado para optimistic update no front-end apenas. Ele não é enviado pelo back-end.
    // Tarefa de referência: https://app.clickup.com/t/86afw9w92
    case 'sending':
      return <AiOutlineClockCircle size="18" color="white" title="Enviando (Otimista)" />;
    case 'enqueued':
      return <BsCheck size="18" color="white" title="Enviando" />;
    case 'sent':
      return <BsCheck size="18" color="white" title="Enviado" />;
    case 'delivered':
      return <BsCheckAll size="18" color="white" title="Entregue" />;
    case 'read':
      return <BsCheckAll size="18" color="#39C0ED" title="Lido" />;
    case 'failed':
      return (
        <MdError
          size="18"
          color="#F93154"
          title={status?.reason ? `${status?.code} ${status?.reason}` : "Falha no envio"}
        />
      );
    default:
      return <></>;
  }
}
